var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7996 12C16.7996 12.7 16.5296 13.4 15.9996 13.93L9.47965 20.45C9.18965 20.74 8.70965 20.74 8.41965 20.45C8.12965 20.16 8.12965 19.68 8.41965 19.39L14.9396 12.87C15.4196 12.39 15.4196 11.61 14.9396 11.13L8.41965 4.60998C8.12965 4.31998 8.12965 3.83998 8.41965 3.54998C8.70965 3.25998 9.18965 3.25998 9.47965 3.54998L15.9996 10.07C16.5296 10.6 16.7996 11.3 16.7996 12Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightDark);
export default __webpack_public_path__ + "static/media/arrow-right-dark.c07c244d3f4b6925bd0f3e79325e2fb4.svg";
export { ForwardRef as ReactComponent };